//ADDED thumbnail gallery switcher! RELATED FILES:
  //main-product.liquid (for pop up and thumbnails section)
  //section-main-product.css (for thumbnails section)
  //media-gallery.js?
  //details-modal.js?

if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();

      this.noListeners = true; //ADDED VARIABLES
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();

      //ADDED
      if (this.noListeners) {
        //thumbnail listeners
        this.querySelectorAll('.modal-gallery-viewer-thumbnail').forEach((element) => {
          element.addEventListener('click', function() {
            document.querySelector('.product-media-modal').setActiveMedia(element.parentElement.dataset.modalTarget);
          });
        });
        //slider button listeners
        this.querySelector('.product-media-modal .slider-button--prev').addEventListener('click', function() {
          //console.log('clicked prev');
          let elem = this.parentElement.querySelector('#Modal-Thumbnails-Container ul');
          if (elem.getElementsByTagName('li').length > 6) {
            let thumbnailPage = parseInt(elem.dataset.thumbnailPage);
            //console.log("prev pre thumb page", typeof thumbnailPage, thumbnailPage, thumbnailPage > 0);
            if (thumbnailPage > 0) {
              thumbnailPage--;
              elem.dataset.thumbnailPage = thumbnailPage;
            }
            elem.setAttribute('style', 'transform: translateX(calc(7rem * -6 * ' + thumbnailPage + '))');
          }
        });
        this.querySelector('.product-media-modal .slider-button--next').addEventListener('click', function() {
          //console.log('clicked next');
          let elem = this.parentElement.querySelector('#Modal-Thumbnails-Container ul');
          if (elem.getElementsByTagName('li').length > 6) {
            let thumbnailPage = parseInt(elem.dataset.thumbnailPage);
            let rightmostPosition = elem.getElementsByTagName('li').length;
            //console.log("next pre thumb page", typeof thumbnailPage, thumbnailPage, rightmostPosition);
            //see "section-main-product.css" for "HARDCODED NUMBER OF THUMBNAILS TO DISPLAY" (6 = width of box, 7 = including spacing)
            if (thumbnailPage < Math.floor(rightmostPosition/6) && thumbnailPage >= 0) {
              thumbnailPage++;
              elem.dataset.thumbnailPage = thumbnailPage;
            }
            let pageOffset = 0;
            if (thumbnailPage == Math.floor(rightmostPosition/6)) {
              //console.log(thumbnailPage == Math.floor(rightmostPosition/6), "page offset if condition: 6 - ", (rightmostPosition % 6));
              pageOffset = (6 - (rightmostPosition % 6)) * 7;
            }
            elem.setAttribute('style', 'transform: translateX(calc(7rem * -6 * ' + thumbnailPage + ' + ' + pageOffset + 'rem))');
          }
        });
        //do not add listeners again
        this.noListeners = false;
      }
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();

      //ADDED update thumbnails/main image in zoomed in media gallery when clicking zoomed out media gallery thumbnail
      this.setActiveMedia(activeMedia.dataset.mediaId);
    }

    //ADDED ENTIRE FUNCTION FOR THUMBNAIL GALLERY VIEWER - images only (?)
    setActiveMedia(mediaId) {
      const activeMedia = this.querySelector(`[data-media-id="${ mediaId }"]`);
      //make large version of current/all other image/media invisible
      this.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('active');
      });
      //make large version of selected image/media visible
      activeMedia.classList.add('active');

      //set visualization/border thickness around active image/media
      const activeThumbnail = this.querySelector(`[data-modal-target="${ mediaId }"]`);
      //turn off border
      this.querySelectorAll('.modal-gallery-viewer-thumbnail').forEach((element) => element.removeAttribute('aria-current'));
      //turn on border
      activeThumbnail.querySelector('button').setAttribute('aria-current', true);

      //scroll active thumbnail to leftmost position and animate (see "slider-button--next" listener for reference)
      let elem = this.parentElement.querySelector('#Modal-Thumbnails-Container ul');
      if (elem.getElementsByTagName('li').length > 6) {
        /*
        let pos = activeThumbnail.dataset.modalMediaPosition - 1;
        if (pos > elem.getElementsByTagName('li').length - 6) {
          pos = elem.getElementsByTagName('li').length - 6;
        }
        elem.setAttribute('style', 'transform: translateX(calc(7rem * -' + pos + '))');
        elem.dataset.thumbnailPage = Math.floor((pos + 1) / 6);
        */
        elem.dataset.thumbnailPage = Math.floor((activeThumbnail.dataset.modalMediaPosition - 1) / 6);
        let pageOffset = 0;
        if (elem.dataset.thumbnailPage == Math.floor(elem.getElementsByTagName('li').length/6)) {
          pageOffset = (6 - (elem.getElementsByTagName('li').length % 6)) * 7;
        }
        elem.setAttribute('style', 'transform: translateX(calc(7rem * -6 * ' + elem.dataset.thumbnailPage + ' + ' + pageOffset + 'rem))');
      }
    }
  });
}
